import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import store from './store';
import 'semantic-ui-css/semantic.min.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import './index.css';
// import "react-image-gallery/styles/css/image-gallery.css"
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import App from './components/App';

ReactDOM.render(
  <Provider store={store}>
    <>
      <ReduxToastr
        position="top-left"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
      />
      <App />
    </>
  </Provider>,
  document.querySelector('#root')
);
